(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mfy-poster-process-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProcess(root) {
      if (!root || root.dataset.processReady === "true") return;
      var panels = Array.prototype.slice.call(root.querySelectorAll("[data-process-panel]"));
      var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-process-tab]"));
      if (!panels.length || panels.length !== tabs.length) return;

      root.style.setProperty("--mfy-process-count", tabs.length);
      var activeIndex = 0;
      var timer = 0;
      var autoplay = root.dataset.autoplay === "true";
      var interval = Math.max(3000, Number(root.dataset.interval || 5000));
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      function select(index, focusTab) {
        activeIndex = (index + panels.length) % panels.length;
        panels.forEach(function (panel, panelIndex) {
          var active = panelIndex === activeIndex;
          panel.hidden = !active;
          panel.classList.toggle("is-active", active);
        });
        tabs.forEach(function (tab, tabIndex) {
          var active = tabIndex === activeIndex;
          tab.classList.toggle("is-active", active);
          tab.setAttribute("aria-selected", active ? "true" : "false");
          tab.tabIndex = active ? 0 : -1;
        });
        var navigation = tabs[activeIndex].parentElement;
        if (navigation && navigation.scrollWidth > navigation.clientWidth) {
          navigation.scrollTo({
            left: tabs[activeIndex].offsetLeft - (navigation.clientWidth - tabs[activeIndex].offsetWidth) / 2,
            behavior: reduceMotion ? "auto" : "smooth"
          });
        }
        if (focusTab) tabs[activeIndex].focus({ preventScroll: true });
      }

      function stop() {
        window.clearInterval(timer);
        timer = 0;
      }

      function start() {
        stop();
        if (!autoplay || reduceMotion || panels.length < 2) return;
        timer = window.setInterval(function () { select(activeIndex + 1, false); }, interval);
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener("click", function () {
          select(index, false);
          start();
        });
        tab.addEventListener("keydown", function (event) {
          if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
          event.preventDefault();
          select(activeIndex + (event.key === "ArrowRight" ? 1 : -1), true);
          start();
        });
      });

      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);
      root.addEventListener("focusin", stop);
      root.addEventListener("focusout", start);
      root.dataset.processReady = "true";
      select(0, false);
      start();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll("[data-mfy-process]").forEach(initProcess);
    }

    initAll(document);
    document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
    document.addEventListener("shopify:block:select", function (event) {
      var panel = event.target.closest && event.target.closest("[data-process-panel]");
      var root = panel && panel.closest("[data-mfy-process]");
      if (!root || !panel) return;
      var tab = root.querySelector('[data-process-tab][data-process-index="' + panel.dataset.processIndex + '"]');
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
